import { DraggableModalPanel } from '../ui/DraggableModalPanel';
import { LoadingSpinner } from '../ui/LoadingSpinner';

type SupportAiSuggestModalProps = {
  open: boolean;
  loading: boolean;
  error: string | null;
  text: string;
  isInternal: boolean;
  onTextChange: (value: string) => void;
  onClose: () => void;
  onUse: () => void;
  onRegenerate: () => void;
};

export function SupportAiSuggestModal({
  open,
  loading,
  error,
  text,
  isInternal,
  onTextChange,
  onClose,
  onUse,
  onRegenerate,
}: SupportAiSuggestModalProps) {
  const title = isInternal ? 'Sugestão de nota interna' : 'Sugestão de resposta ao cliente';
  const useLabel = isInternal ? 'Usar na nota' : 'Usar na resposta';

  return (
    <DraggableModalPanel
      open={open}
      title={title}
      subtitle="Revise o texto com mais espaço e só então aplique na caixa de mensagem."
      onClose={onClose}
      className="w-full max-w-2xl"
      overlayClassName="z-[60]"
      footer={
        <div className="erp-btn-actions">
          <button type="button" className="erp-btn-secondary" onClick={onClose}>
            Descartar
          </button>
          <button
            type="button"
            className="erp-btn-secondary"
            onClick={onRegenerate}
            disabled={loading}
          >
            Gerar novamente
          </button>
          <button
            type="button"
            className="erp-btn-primary"
            onClick={onUse}
            disabled={loading || !text.trim()}
          >
            {useLabel}
          </button>
        </div>
      }
    >
      {loading ? (
        <LoadingSpinner label="Gerando sugestão com IA..." />
      ) : error ? (
        <div className="space-y-3 py-4">
          <p className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800">
            {error}
          </p>
          <p className="text-xs text-secondary-500">
            Verifique a chave, o endpoint base (sem /chat/completions) e o modelo nas
            configurações de inteligência artificial.
          </p>
        </div>
      ) : (
        <label className="block">
          <span className="mb-1 block text-xs font-medium text-secondary-600">Texto sugerido</span>
          <textarea
            className="erp-input min-h-[16rem] w-full text-sm leading-6"
            value={text}
            onChange={(event) => onTextChange(event.target.value)}
            maxLength={2000}
          />
        </label>
      )}
    </DraggableModalPanel>
  );
}
